import { useEffect, useState } from "react"
import { httpGet, httpPost } from "../../../../../modules/Backend"
import Collapsible from "../../../../lib/Collapsible";
import { Button } from "react-aria-components";
import IconChevronUp from "../../../../../assets/icons/icon-chevron-up-blue.svg"
import IconChevronDown from "../../../../../assets/icons/icon-chevron-down-blue.svg"

interface ISidePanelInfoSmall {
    descriptor: string,
    id: string,
    entityName: string
}

export default function SidePanelLocations({ descriptor, id, entityName }: ISidePanelInfoSmall) {
    const [data, setData] = useState<any>()
    const [loading, setLoading] = useState<boolean>(false);
    const [collapsed, setCollapsed] = useState<boolean>(true);

    async function getData() {
        setLoading(true)
        setCollapsed(false)
        const result = await httpPost(`api/caseMaterials/list`, {
            take: 6,
            id: id,
            keysets: []
        })
        setData(result.data.caseMaterials)
        setLoading(false);
    }

    async function showData() {
        if (!data && !loading) await getData()
        else { setCollapsed(prev => !prev) }
    }

    useEffect(() => {
        setData(undefined);
        setCollapsed(true);
        setLoading(false)
    }, [id, entityName])

    return (
        <div className="side-panel__info-box margin__top--s">
            <div className="display--flex justifyContent--space-between alignItems--center">
                <p className="small">{descriptor}</p>
                <Button className={"button button--with-icon alignSelf--baseline margin__right--xxs12"} onPress={showData}>
                    <img src={`${collapsed ? IconChevronDown : IconChevronUp}`}></img>
                </Button>
            </div>

            <div className="">
                <Collapsible isCollapsed={collapsed}>
                    <>
                        {data && data.map((x: any) =>
                            <div className="side-panel__breadcrumb-wrapper">
                                <p className="xsmall">{x.quantity}</p>
                                <div className="side-panel__blue-background">
                                    <p className="breadcrumb">{x.currentLocation}</p>
                                </div>
                            </div>
                        )}
                        {loading && [...Array(3)].map(x =>

                            <div className="side-panel__breadcrumb-wrapper">
                                <div className="loaders loaders__breadcrumb">

                                </div>
                            </div>
                        )}
                    </>
                </Collapsible>

            </div>

        </div>
    )
}